// extracted by mini-css-extract-plugin
module.exports = {"marqueeContainer":"_1HWDZ","marquee":"e77D3","marqueeContent":"_1q7Xk","scroll":"_3X04o"};